import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Globalize from '@sprinx/globalize';
import NumberFieldPreviewNaked from '../NumberFieldPreviewNaked';
import FieldPreviewNakedAdornment from '../FieldPreviewNakedAdornment';
import useMuiFieldsContext from '../useMuiFieldsContext';
import CurrencySymbol from '../CurrencySymbol';

function PriceFieldPreviewNaked(_ref) {
  var pcur = _ref.currency,
      pcf = _ref.currencyFormat,
      pdp = _ref.decimalPrecision,
      rest = _objectWithoutProperties(_ref, ["currency", "currencyFormat", "decimalPrecision"]);

  var _useMuiFieldsContext = useMuiFieldsContext(),
      currencyDecimalPrecision = _useMuiFieldsContext.currencyDecimalPrecision,
      currencyFormat = _useMuiFieldsContext.currencyFormat,
      defaultCurrency = _useMuiFieldsContext.defaultCurrency;

  var decimalPrecision = pdp || currencyDecimalPrecision;
  var currency = pcur || defaultCurrency;
  var curF = pcf || currencyFormat;
  var symbolplacement = Globalize.locale().main('numbers/currencyFormats-numberSystem-latn/standard');
  var InputProps = /^¤/.test(symbolplacement) ? {
    startAdornment: /*#__PURE__*/React.createElement(FieldPreviewNakedAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(CurrencySymbol, {
      currency: currency,
      variant: curF,
      noWrap: true
    }))
  } : {
    endAdornment: /*#__PURE__*/React.createElement(FieldPreviewNakedAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(CurrencySymbol, {
      currency: currency,
      variant: curF
    }))
  };
  return /*#__PURE__*/React.createElement(NumberFieldPreviewNaked, _extends({}, rest, {
    decimalPrecision: decimalPrecision,
    InputProps: InputProps
  }));
}

PriceFieldPreviewNaked.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * Kod meny, ve ktere je hodnota. Pokud neni definovana, pouzije se nastaveni z MuiFieldsProvider.
   */
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    code: PropTypes.string.isRequired
  })]),

  /**
   * Format zobrazeni meny. Pokud neni definovano pouzije se nastaveni z MuiFieldsProvider.
   * - 'accounting' -> XXX Kč
   * - 'code' -> XXX CZK
   */
  currencyFormat: PropTypes.oneOf(['accounting', 'code']),

  /**
   * Pocet desetinnych mist.
   * Pokud neni definovana pouzite se nastaveni z Provideru.
   */
  decimalPrecision: PropTypes.number,
  decoration: PropTypes.oneOf(['none', 'strike']),
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({
    endAdornment: PropTypes.node,
    startAdornment: PropTypes.node
  }),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large', 'inherit']),
  style: PropTypes.shape({}),
  value: PropTypes.number
};
PriceFieldPreviewNaked.defaultProps = {
  align: undefined,
  className: undefined,
  color: undefined,
  currency: undefined,
  currencyFormat: undefined,
  decimalPrecision: undefined,
  decoration: 'none',
  display: undefined,
  fullWidth: false,
  InputProps: undefined,
  margin: undefined,
  size: undefined,
  style: undefined,
  value: undefined
};
export default PriceFieldPreviewNaked;